import React from 'react'
import Hero from '../components/Hero'
import NewsletterSignup from '../components/NewsletterSignup'

const HomePage: React.FC = () => {
  return (
    <div>
      <Hero />
      <NewsletterSignup />
    </div>
  )
}

export default HomePage